<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .main-text {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);

    .tag-span {
      @include colors.color(activityReply_50);
    }

    .text {
      display: flex;
      flex-direction: column;
      gap: 0;

      .title {
        @include mixins.h1();
      }

      .summary {
        @include mixins.body2();
      }
    }

    .icon-container {
      display: flex;
      gap: utils.in_rem(16px);

      .frame {
        @include colors.background-color(interfaceWhite);
        width: utils.in_rem(39.2px);
        height: utils.in_rem(39.2px);
        padding: utils.in_rem(3.92px);
        border-radius: utils.in_rem(3.92px);
        display: flex;
        justify-content: center;
        align-items: center;

        > img {
          width: utils.in_rem(31.36px);
          height: utils.in_rem(31.36px);
        }
      }
    }
  }
</style>

<script>
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";
  import { icons } from "../../../../../pages/Meetings/utils";
</script>

<div class="main-text">
  <StatusTag kind="success"><span class="tag-span">NOTETAKER</span></StatusTag>
  <div class="text">
    <span class="title">Smart notes, smarter conversations</span>
    <span class="summary">
      Get transcripts and AI summaries for all your calls and meetings with
      SourceWhale Notetaker
    </span>
  </div>
  <div class="icon-container">
    {#each Object.entries(icons) as [platform, icon]}
      <div class="frame">
        <img src={icon} alt={platform} />
      </div>
    {/each}
  </div>
</div>
